import React, { useState } from "react";
import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemButton,
  Paper,
  Typography,
  Modal
} from "@mui/material";
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import CircularProgress from "@mui/material/CircularProgress";
import useApp from "../../store/contexts/AppContext";
import CoinIcon from '../../images/coin-icon.svg';

const styleForModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: '#826F6F',
  color: '#fff',
  border: '2px solid #000',
  boxShadow: 24,
  p: 2,
};

export default function SpectatorModeChargeRoomFee({ roomData }) {
  const {
    payRoomFeeForSpectatorModeByRoomIdApiCall,
  } = useApp();

  const roomId = roomData.id;
  const roomName = roomData.name;
  const roomWatchFee = roomData.watch_fee;

  const [isLoadingCoinPayment, setIsLoadingCoinPayment] = React.useState(false);

  const [openModal, setOpenModal] = useState(true);

  const handlePayWithCoinCheckout = async () => {
    setIsLoadingCoinPayment(true);

    await payRoomFeeForSpectatorModeByRoomIdApiCall({
      roomId
    });

    setIsLoadingCoinPayment(false);
  };

  const handleClose = () => {
    // Prevent the modal from being dismissed
    // You can add custom logic here if needed
  };

  return (
    <div>

      <Modal
        open={openModal}
        onClose={handleClose}
        disableEscapeKeyDown
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box sx={styleForModal}>
          <Typography id="transition-modal-title" variant="h6" component="h2" textAlign={'center'}>
            Pay {roomWatchFee} {roomWatchFee > 1 ? 'coin' : 'coins'} Watch Fee For Room: <b>{roomName}</b>
          </Typography>
          <Typography id="transition-modal-title" variant="h6" style={{ fontSize: '12px', color: 'gold' }} textAlign={'center'}>
            The coin will be deducted from your account available coins
          </Typography>
          <div>
            <Grid item xs={12} md={6}>
              <Paper variant="outlined" sx={{ p: 2 }}>
                <List component="nav">
                  <ListItem disablePadding>
                    <ListItemButton
                      sx={{ background: "#F7F7F7", borderRadius: 5, border: 1, cursor: 'pointer' }}
                      onClick={handlePayWithCoinCheckout}
                      disabled={isLoadingCoinPayment}
                    >
                      <ListItemAvatar>
                        <Avatar sx={{ background: "#F7F7F7" }}>
                          <img src={CoinIcon} width={30} alt="Coin icon" />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary="Pay With Coin"
                        secondary={false ? 'Secondary text' : null}
                      />

                      {isLoadingCoinPayment ? (
                        <IconButton edge="end" aria-label="loading">
                          <CircularProgress size={20} />
                        </IconButton>
                      ) : null}
                    </ListItemButton>
                  </ListItem>
                </List>
              </Paper>
            </Grid>
          </div>
        </Box>
      </Modal>

    </div>
  );
}
